export default __webpack_public_path__ + "static/imda20192ndprize-303664be9ed74c7f57be9b1f4705776a.jpg";